import WithApplicationId from 'utils/WithApplicationId';
import CompanyInfoStepWithApplicationId from './components/CompanyInfoStepWithApplicationId/CompanyInfoStepWithApplicationId';

export default WithApplicationId({
	Component: CompanyInfoStepWithApplicationId,
	stepName: 'Tell us about your company',
});
